var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61887 0.24904C6.18254 0.266182 6.72832 0.364602 7.2571 0.544441H7.30989C7.34568 0.561441 7.37252 0.58023 7.39042 0.597229C7.58815 0.660755 7.77515 0.732332 7.95409 0.830752L8.29409 0.982855C8.4283 1.05443 8.58935 1.18775 8.67882 1.24232C8.76829 1.29511 8.86671 1.34969 8.94724 1.41143C9.94127 0.651807 11.1483 0.240235 12.3919 0.24904C12.9565 0.24904 13.5202 0.328813 14.0561 0.508652C17.3585 1.58232 18.5485 5.20594 17.5545 8.37326C16.9908 9.99181 16.0692 11.469 14.8622 12.676C13.1345 14.3491 11.2386 15.8343 9.19776 17.1138L8.97408 17.2489L8.74145 17.1048C6.69343 15.8343 4.78678 14.3491 3.04296 12.667C1.84404 11.46 0.921578 9.99181 0.348956 8.37326C-0.66208 5.20594 0.527901 1.58232 3.86611 0.489863C4.12558 0.400391 4.3931 0.33776 4.66152 0.302866H4.76888C5.0203 0.266182 5.26993 0.24904 5.52045 0.24904H5.61887Z",
    fill: "#D06CFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.631ecfb6.svg";
export { ForwardRef as ReactComponent };